// import axios from "axios";
// import serviceHelper from "../../helpers/functions/service.helper";
// import {getQueriesForElement} from "@testing-library/react";
//
// async function merchants(query) {
//     const queryString = serviceHelper.queryString(query);
//     const merchantsResponse = await axios.get(`ewallet_integration/merchants?${queryString}`, {withCredentials: true,});
//     return merchantsResponse?.data;
// }
// async function merchantSettlementListing(query) {
//     const queryString = serviceHelper.queryString(query);
//     const listingResponse = await axios.get(`ewallet_integration/merchant_settlement?${queryString}`, {withCredentials: true,});
//     return listingResponse?.data;
// }
//
// async function createMerchantSettlement(params) {
//     const merchantSettlementResponse = await axios.post(`ewallet_integration/merchant_settlement`, params,{withCredentials: true,});
//     return merchantSettlementResponse?.data;
// }
//
// export default {
//     merchants,
//     merchantSettlementListing,
//     createMerchantSettlement,
// }

import axios from "axios";
import serviceHelper from "../../helpers/functions/service.helper";

// ENV Config
const BASE_URL = process.env.REACT_APP_EWALLET_SERVER_URL;
const APP_ID = process.env.REACT_APP_APP_ID;
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

/**
 * Generate headers with encoded x-api-token
 */
function getHeaders() {
    const raw = `${APP_ID}|#|${SECRET_KEY}`;
    const encodedToken = btoa(raw); // Browser-safe Base64
    return {
        'x-api-token': encodedToken,
        'Content-Type': 'application/json',
        withCredentials: true,
    };
}

/**
 * Helper for GET requests
 */
async function get(path, query = {}) {
    const queryString = serviceHelper.queryString(query);
    const url = `${BASE_URL}${path}?${queryString}`;
    const headers = getHeaders();
    const response = await axios.get(url, { headers });
    return response?.data;
}

/**
 * Helper for POST requests
 */
async function post(path, body = {}) {
    const url = `${BASE_URL}${path}`;
    const headers = getHeaders();
    const response = await axios.post(url, body, { headers });
    return response?.data;
}

// Exported service functions
async function merchants(query) {
    return get(`integration/merchants`, query);
}

async function merchantSettlementListing(query) {
    return get(`integration/merchant_settlements`, query);
}

async function settlementListingByMerchantId(merchant_id, query) {
    return get(`integration/merchant_settlement/merchant/${merchant_id}`, query);
}

async function createMerchantSettlement(merchant_id, params) {
    return post(`integration/merchant_settlements/${merchant_id}`, params);
}

export default {
    merchants,
    merchantSettlementListing,
    createMerchantSettlement,
    settlementListingByMerchantId,
};
